import { ReactElement } from 'react';
import { generatePath, Route } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
import { Address } from 'viem';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';
import { Pool } from 'modules/pool/screens/Pool/Pool';

const POOL_PATH = `/pool`;

export const PoolRoutesConfig = createRouteConfig(
  {
    pool: {
      path: POOL_PATH,
      generatePath: (poolAddress: Address) =>
        generatePath(`${POOL_PATH}/?poolAddress=${poolAddress}`),
      useParams: (): { poolAddress: Address } => {
        const [poolAddress] = useQueryParam('poolAddress', StringParam);

        return { poolAddress: (poolAddress || '') as Address };
      },
    },
  },
  POOL_PATH,
);

export function getPoolRoutes(): ReactElement {
  return (
    <>
      <Route element={<Pool />} path={PoolRoutesConfig.pool.path} />
    </>
  );
}
